/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'

import React from 'react'
import { View, Text, Icon, Button } from '@components/atoms'
import { HomeSideNav, Footer } from '@components/systems'
import Accordion from '@mui/material/Accordion'
import AccordionSummary from '@mui/material/AccordionSummary'
import AccordionDetails from '@mui/material/AccordionDetails'

import config from '@configs'
import { HomeNavMenuType } from '@redux/index'
import { grey } from '@mui/material/colors'

const ManualsPage = () => {
	const menuList: HomeNavMenuType[] = config.supportMenu()
	const now = new Date()

	const kdm6Manual = config.manual('KDM6')
	const kdm4Manual = config.manual('KDM4')

	const onManualOpenClick = (code: string, language: string) => {
		const pdfUrlArr: { [key: string]: { title: string; link: string } } =
			config.manual(code)
		const pdfUrl = pdfUrlArr[language].link + '?v=' + now.toString()
		window.open(pdfUrl, '_blank')
	}

	const onManualDownloadClick = (code: string, language: string) => {
		const pdfUrlArr: { [key: string]: { title: string; link: string } } =
			config.manual(code)
		const pdfUrl = pdfUrlArr[language].link + '?v=' + now.toString()
		const fileName = 'my-file.pdf'

		const aLink = document.createElement('a')
		aLink.href = pdfUrl
		aLink.setAttribute('download', fileName)
		document.body.appendChild(aLink)
		aLink.click()
		document.body.removeChild(aLink)
	}

	return (
		<View css={style}>
			<View className="outerView">
				<HomeSideNav menu={menuList} selectedIndes={0} />

				<View className="contentOuterView">
					<Text category="h1">Manuals</Text>
					<View className="contentView">
						<View>
							<Accordion>
								<AccordionSummary
									aria-controls={'kedem6-content'}
									id={'kedem6-header'}
									expandIcon={<Icon name="menu-down" />}
								>
									<Text category="h5">Kedem 6</Text>
								</AccordionSummary>
								<AccordionDetails>
									<View className="userManualView">
										{Object.keys(kdm6Manual).map(aLang => {
											const title = kdm6Manual[aLang].title
											return (
												<View key={`KDM6-${aLang}`} className="userManualInnerView">
													<Text className="userManualTitle">
														{`Kedem 6 User Manual ${title}`}
													</Text>

													<View>
														<Button
															className="userManualDownloadBtn"
															variant="contained"
															size="small"
															color="inherit"
															onClick={() => onManualOpenClick('KDM6', aLang)}
														>
															Open
														</Button>

														<Button
															className="userManualDownloadBtn"
															variant="contained"
															size="small"
															color="inherit"
															onClick={() => onManualDownloadClick('KDM6', aLang)}
														>
															Download
														</Button>
													</View>
												</View>
											)
										})}
									</View>
								</AccordionDetails>
							</Accordion>

							<Accordion>
								<AccordionSummary
									aria-controls={'kedem6-content'}
									id={'kedem6-header'}
									expandIcon={<Icon name="menu-down" />}
								>
									<Text category="h5">Kedem 4</Text>
								</AccordionSummary>
								<AccordionDetails>
									<View className="userManualView">
										{Object.keys(kdm4Manual).map(aLang => {
											const title = kdm4Manual[aLang].title
											return (
												<View key={`KDM4-${aLang}`} className="userManualInnerView">
													<Text className="userManualTitle">
														{`Kedem 4 User Manual ${title}`}
													</Text>

													<View>
														<Button
															className="userManualDownloadBtn"
															variant="contained"
															size="small"
															color="inherit"
															onClick={() => onManualOpenClick('KDM4', aLang)}
														>
															Open
														</Button>

														<Button
															className="userManualDownloadBtn"
															variant="contained"
															size="small"
															color="inherit"
															onClick={() => onManualDownloadClick('KDM4', aLang)}
														>
															Download
														</Button>
													</View>
												</View>
											)
										})}
									</View>
								</AccordionDetails>
							</Accordion>
						</View>
					</View>
				</View>
			</View>

			<Footer />
		</View>
	)
}

export default ManualsPage

const style = css({
	position: 'relative',
	width: '100%',

	'.outerView': {
		display: 'flex',
		width: '100%',
		paddingTop: '2rem',
		paddingBottom: '2rem',
		borderBottom: '1px solid',
		borderColor: grey[300],

		'.sideMenuView': {
			width: '15rem',
			borderRight: '1px solid',
			borderColor: grey[300],

			'.sideMenuButton': {
				width: '100%',
				'.sideMenuTitle': {},
			},
		},

		'.contentOuterView': {
			width: 'calc(100% - 15rem)',
			minHeight: 'calc(100vh - 10rem)',
			padding: '2rem',
			borderLeft: '1px solid',
			borderColor: grey[300],

			'.contentView': {
				width: '100%',
				right: 0,
				left: 0,
				margin: 'auto',
				paddingTop: '3rem',
				borderTop: '1px solid',
				borderColor: grey[500],

				'.userManualView': {
					padding: '1rem 0 ',
					borderTop: '1px solid',
					borderColor: grey[300],
					textAlign: 'left',

					'.userManualInnerView': {
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
						borderBottom: '1px solid',
						borderColor: grey[300],

						'.userManualTitle': {
							color: grey[700],
						},

						'.userManualDownloadBtn': {
							height: '2rem',
							marginLeft: '0.5rem',
						},
					},
				},
			},
		},
	},

	'@media (max-width: 1350px)': {
		'.outerView': {
			'.contentOuterView': {
				width: '100%',
				height: 'auto',
				padding: '2rem',

				'.contentView': {},
			},
		},
	},

	'@media (max-width: 550px)': {
		'.outerView': {
			'.contentOuterView': {
				padding: '1rem',

				'.contentView': {
					'.userManualView': {
						'.userManualInnerView': {
							display: 'block',
							paddingBottom: '1rem',
						},
					},
				},
			},
		},
	},
})
